import { filter, remplazarPorTildeASinTilde } from "../../helpers/Buscador";
import { fetchConToken } from "../../helpers/fetch";
import { handleErrorApi } from "../../helpers/randoms";
import ComprasService from "../../services/ComprasService";
import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";

export const ConsultarOferentes = (textoBuscado = "") => async (dispatch) => {
    dispatch(startSpinner());
    try{
        const response = await ComprasService.consultarOferentesAbm();
        const body = await response.json();
        let resultados = body;
        if(response.ok){
            if(textoBuscado !== ""){
              resultados.filter(n => filter(remplazarPorTildeASinTilde(n.descripcion), remplazarPorTildeASinTilde(textoBuscado)));
            }
            dispatch({
                type: types.oferentesAbmSuccess,
                payload: body
            })
            dispatch(finishSpinner());
        }else{
            throw body;
        }
    }catch(error){
        dispatch(finishSpinner());
        dispatch({type: types.oferentesAbmError})
        handleErrorApi(dispatch, error, "Error al traer los oferentes", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const guardarOferente = (id, data) => async (dispatch) => {
    try {
      dispatch(startSpinner());
      let response;
      if (id) {
        response = await fetchConToken(`Compras/Oferentes/${id}`, data, "PUT");
      } else {
        response = await fetchConToken(`Compras/Oferentes`, data, "POST");
      }

      const body = await response.json();

      if (response.ok) {
        dispatch(
          startAlerta(
            "Oferente guardado correctamente",
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(finishSpinner());
        dispatch(ConsultarOferentes());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar el oferente",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
}

export const eliminarOferente = (id) => async (dispatch) => {
    try {
      dispatch(startSpinner());
      let response = await fetchConToken(
        `Compras/Oferentes/${id}`,
        {},
        "DELETE"
      );
  
      const body = await response.json();
  
      if (response.ok) {
        dispatch(startAlerta("Oferente eliminado correctamente", 'success', 'Comando Exitoso'))
        dispatch(finishSpinner());
        dispatch(ConsultarOferentes());
      } else {
        throw body
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(dispatch, error, "Error al eliminar el oferente", "Ha ocurrido un error. Intente nuevamente")
    }
  };
  
  export const BuscarOferente = (text) => (dispatch) =>{
    dispatch({
        type : types.oferentesBuscarAbm,
        payload : text
    });
}

export const NuevoMailOferente = (idOferente, mail) => async (dispatch) => {
  try {
    let data ={
      IdOferente : idOferente, 
      Email: mail
    }
    dispatch(startSpinner());
    let response = await fetchConToken(
      `Compras/Oferentes/NuevoEmail`,
      data,
      "POST"
    );

    const body = await response.json();

    if (response.ok) {
      dispatch(startAlerta("Mail agregado correctamente", 'success', 'Comando Exitoso'))
      dispatch(FetchEmailsOferentes(idOferente));
      dispatch(ConsultarOferentes());
      dispatch(finishSpinner());
    } else {
      throw body
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(dispatch, error, "Error al agregar el mail.", "Ha ocurrido un error. Intente nuevamente")
  }
};

export const BajaMailOferente = (idOferente, idEmailOferente) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    let response = await fetchConToken(
      `Compras/Oferentes/BajaMail/${idOferente}/${idEmailOferente}`,
      {},
      "PUT"
    );

    const body = await response.json();

    if (response.ok) {
      dispatch(startAlerta("Mail eliminado correctamente", 'success', 'Comando Exitoso'))
      dispatch(FetchEmailsOferentes(idOferente));
      dispatch(ConsultarOferentes());
      dispatch(finishSpinner());
    } else {
      throw body
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(dispatch, error, "Error al eliminar el mail.", "Ha ocurrido un error. Intente nuevamente")
  }
};

export const FetchEmailsOferentes = (idOferente) => async (dispatch) => {
  try {

    dispatch(startSpinner());
    let response = await fetchConToken(
      `Compras/Oferentes/TraerEmails/${idOferente}`,
      {},
      "GET"
    );

    const body = await response.json();

    if (response.ok) {
      dispatch({type: types.mailsOferentesSuccess,
        payload: body
      })
      dispatch(finishSpinner());
    } else {
      throw body
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(dispatch, error, "Error al agregar el mail.", "Ha ocurrido un error. Intente nuevamente")
  }
};

export const desSeleccionarMailOferente = () =>{
  return{
      type: types.mailsOferentesClean,
  }
}

export const TraerOferentesPorCotizacion = (idCotizacion) => async (dispatch) =>{
  dispatch(startSpinner())
  try{
      let response = await fetchConToken(
        `Compras/Oferentes/TraerOferentesPorCotizacion/${idCotizacion}`,
        {},
        "GET"
      );
      const body = await  response.json();
      if(response.ok){
          dispatch({type: types.getOferentesPorCotizacionSuccess,
          payload:body
      })
      dispatch(finishSpinner());
      }else{
          throw body; 
      }
  }catch(error){
      dispatch(finishSpinner());
      handleErrorApi(dispatch, error, "Error al traer los oferentes","Ha ocurrido un error. Intente nuevamente" )
  }
}